import { Card, Col, Row, Table } from 'antd';
import { FC } from 'react';
import { FormattedDate } from 'react-intl';
import { getStateString } from '../Table';
import { RentResponse } from '../../../../api/client/data-contracts';
import { useRents } from '../useRents';
import { useHistory } from 'react-router-dom';
import { Price } from '../rent-lines';

const columns = [
  {
    title: (
      <span className='hp-badge-size hp-font-weight-400 hp-text-color-black-60 hp-text-color-dark-50 hp-text-uppercase'>
        Cliente
      </span>
    ),
    dataIndex: 'customer',
    key: 'customer',
    render: (text: string) => (
      <p className='hp-mb-0 hp-text-color-black-100 hp-text-color-dark-0'>
        {text}
      </p>
    ),
  },

  {
    title: (
      <span className='hp-badge-size hp-font-weight-400 hp-text-color-black-60 hp-text-color-dark-50 hp-text-uppercase'>
        Código do aluguer
      </span>
    ),
    dataIndex: 'code',
    key: 'code',
    render: (text: string) => (
      <p className='hp-mb-0 hp-text-color-black-100 hp-text-color-dark-0'>
        {text}
      </p>
    ),
  },
  {
    title: (
      <span className='hp-badge-size hp-font-weight-400 hp-text-color-black-60 hp-text-color-dark-50 hp-text-uppercase'>
        Valor do alguger
      </span>
    ),
    dataIndex: 'paymentValue',
    key: 'paymentValue',
    render: (text: string) => (
      <p className='hp-mb-0 hp-text-color-black-100 hp-text-color-dark-0'>
        <Price value={Number(text)} />
      </p>
    ),
  },
  {
    title: (
      <span className='hp-badge-size hp-font-weight-400 hp-text-color-black-60 hp-text-color-dark-50 hp-text-uppercase'>
        Com IVA
      </span>
    ),
    dataIndex: 'paymentValueWithVat',
    key: 'paymentValueWithVat',
    render: (text: string) => (
      <p className='hp-mb-0 hp-text-color-black-100 hp-text-color-dark-0'>
        <Price value={Number(text)} />
      </p>
    ),
  },
  {
    title: (
      <span className='hp-badge-size hp-font-weight-400 hp-text-color-black-60 hp-text-color-dark-50 hp-text-uppercase'>
        Estado
      </span>
    ),
    dataIndex: 'state',
    key: 'state',
    render: (text: string) => (
      <p className='hp-mb-0 hp-text-color-black-100 hp-text-color-dark-0'>
        {getStateString(text as RentResponse['state'])}
      </p>
    ),
  },

  {
    title: (
      <span className='hp-badge-size hp-font-weight-400 hp-text-color-black-60 hp-text-color-dark-50 hp-text-uppercase'>
        Data do início
      </span>
    ),
    dataIndex: 'startDate',
    key: 'startDate',
    render: (text: string) => (
      <p className='hp-mb-0 hp-text-color-black-100 hp-text-color-dark-0'>
        <FormattedDate value={text} />
      </p>
    ),
  },

  {
    title: (
      <span className='hp-badge-size hp-font-weight-400 hp-text-color-black-60 hp-text-color-dark-50 hp-text-uppercase'>
        Data do fim
      </span>
    ),
    dataIndex: 'endDate',
    key: 'endDate',
    render: (text: string) => (
      <p className='hp-mb-0 hp-text-color-black-100 hp-text-color-dark-0'>
        <FormattedDate value={text} />
      </p>
    ),
  },
];

const LattestRentsCard: FC = () => {
  const { rentsQuery } = useRents();
  const history = useHistory();
  const data = rentsQuery.data?.slice(0, 5).map((rent) => ({
    startDate: rent.startDate,
    endDate: rent.endDate,
    customer: rent.customer.description,
    paymentValue: rent.paymentTotal,
    paymentValueWithVat: rent.paymentTotalWithVat,
    state: rent.state,
    code: rent.code,
  }));
  return (
    <Card className='hp-border-color-black-40 hp-project-ecommerce-table-card'>
      <Row>
        <Col span={24}>
          <Row align='middle' justify='space-between' className='hp-mb-32'>
            <h5 className='hp-mb-0'>Últimos Aluguers</h5>

            <p
              onClick={() => history.push('/apps/cockpit/rents')}
              className='hp-p1-body hp-mb-0 hp-font-weight-500 hp-text-color-black-100 hp-text-color-dark-0 hp-text-color-dark-0'
            >
              Ver todos os aluguers
            </p>
          </Row>

          <Table
            columns={columns}
            dataSource={data}
            pagination={false}
            scroll={{ x: 700 }}
            loading={rentsQuery.isLoading}
          />
        </Col>
      </Row>
    </Card>
  );
};

export default LattestRentsCard;
